import React, { useState, useEffect, useMemo, useContext } from 'react';
import { TRole } from 'models/auth';
import { logger } from 'utils';
import AuthContext from './AuthProvider';

export const ViralLoopsContext = React.createContext({
  viralLoops: null,
  viralLoopsCampaign: null,
  viralLoopsUser: null,
});

const ViralLoopsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [viralLoops, setViralLoops] = useState<any>(null);
  const [viralLoopsCampaign, setViralLoopsCampaign] = useState<any>(null);
  const [viralLoopsUser, setViralLoopsUser] = useState<any>(null);

  const { appUser } = useContext(AuthContext);
  useEffect(() => {
    const loadViralLoops = async () => {
      const SCRIPT_SRC = 'https://app.viral-loops.com/widgetsV2/core/loader.js';
      try {
        await new Promise((resolve, reject) => {
          if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
            resolve(true);
          } else {
            const script = document.createElement('script');
            script.src = SCRIPT_SRC;
            script.id = 'viral-loops-loader';
            script.dataset.campaignId = process.env.NEXT_PUBLIC_TEACHER_REFERRAL_CAMPAIGN;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          }
        });
        // @ts-expect-error viral loops is not typed
        setViralLoops(window.ViralLoops);
      } catch (error) {
        logger.error(error);
      }
    };
    loadViralLoops();
  }, []);

  useEffect(() => {
    const identify = async (email?: string) => {
      const campaignId = process.env.NEXT_PUBLIC_TEACHER_REFERRAL_CAMPAIGN;
      let campaign = viralLoops.campaigns.get(campaignId);
      if (!campaign) {
        const isLoadingCampaign = viralLoops.loadingCampaigns.get(campaignId);
        if (isLoadingCampaign) {
          await viralLoops.loadingCampaigns.get(campaignId);
          campaign = viralLoops.campaigns.get(campaignId);
        } else {
          campaign = await viralLoops.getCampaign();
        }
        if (campaign) {
          const user = campaign.getUser();
          setViralLoopsCampaign(campaign);
          if (email) {
            if (!user) {
              await campaign.identify({
                email,
              });
            }
            const viralLoopsUser = campaign.getUser();
            setViralLoopsUser(viralLoopsUser);
          } else {
            campaign.logout();
            setViralLoopsUser(null);
          }
        }
      }
    };
    if (viralLoops) {
      if (appUser) {
        if (appUser.role === TRole.TEACHER && appUser.referral_code) {
          identify(appUser.email);
        }
      } else {
        identify();
      }
    }
  }, [viralLoops, appUser]);

  const value = useMemo(
    () => ({ viralLoops, viralLoopsCampaign, viralLoopsUser }),
    [viralLoops, viralLoopsCampaign, viralLoopsUser],
  );

  return <ViralLoopsContext.Provider value={value}>{children}</ViralLoopsContext.Provider>;
};

export default ViralLoopsProvider;
